import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {  MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar,  } from '@angular/material/snack-bar';
import { LeaderService } from '../../services/leader.service';
import { Router } from '@angular/router';


@Component({
  selector: 'vc-upload-csv',
  standalone: false,
  templateUrl: './upload-csv.component.html',
  styleUrl: './upload-csv.component.scss',
  encapsulation: ViewEncapsulation.None // Allows styling of snackbar and overlays locally
})
export class UploadCsvComponent implements OnInit {
  selectedFile: File | null = null;
  isUploading = false;
  isDragOver = false;
  uploadErrors: string[] = [];
  private readonly maxFileSizeBytes = 10 * 1024 * 1024;

  constructor(
    private leaderService: LeaderService, 
    private snackBar: MatSnackBar,
    private _route:Router
  ) {}

  ngOnInit(): void {}

  private showNotification(message: string, isError: boolean) {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: isError ? ['custom-error-snackbar'] : ['custom-success-snackbar'],
    });
  }

  removeFile(fileInput: HTMLInputElement): void {
    this.selectedFile = null;
    this.uploadErrors = [];
    fileInput.value = '';
  }

  onFileSelected(event: any): void {
    const file: File | null = event?.target?.files?.[0] || null;
    this.validateAndSetFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const file: File | null = event.dataTransfer?.files?.[0] || null;
    this.validateAndSetFile(file);
  }

  private validateAndSetFile(file: File | null): void {
    this.uploadErrors = [];
    if (!file) {
      return;
    }

    if (!file.name.toLowerCase().endsWith('.csv')) {
      this.showNotification('Please select a valid CSV file.', true);
      return;
    }

    if (file.size > this.maxFileSizeBytes) {
      this.showNotification('CSV file must be 10MB or less.', true);
      return;
    }

    this.selectedFile = file;
  }

  uploadFile(): void {
    if (!this.selectedFile) return;
    this.isUploading = true;
    this.uploadErrors = [];

    this.leaderService.uploadCSV(this.selectedFile).subscribe({
      next: (response: any) => {
        const data = response.body ? response.body : response;
        if (data.resultDetails?.[0]?.code === 'R00') {
          this.showNotification(data.resultDetails[0].description, false);
           this.selectedFile = null;
           this.removeFile(document.querySelector('input[type="file"]') as HTMLInputElement);
           this._route.navigate(['/leader-toolkit-goals']);

        } else {
          this.showNotification('CSV uploaded successfully!', false);
           this.selectedFile = null;
           this.removeFile(document.querySelector('input[type="file"]') as HTMLInputElement);
        }
      },
      error: (err: any) => {
        this.isUploading = false;
        const validationMessage: string = err?.error?.validation?.[0]?.message;
        const fallbackDescription: string = err?.error?.resultDetails?.[0]?.description;
        const raw = validationMessage || fallbackDescription;
        if (raw) {
          this.uploadErrors = raw
            .split('\n')
            .map((s: string) => s.trim())
            .filter((s: string) => s.length > 0);
        } else {
          this.uploadErrors = ['An unexpected error occurred. Please try again.'];
        }
      },
      complete: () => this.isUploading = false
    });
  }

  onCancel(): void {
  }
}